import React, { useEffect, useState } from 'react';
import BenefitIllustration from "./BenefitIllustration";
import "./BIPage.css"
import DotsLoader from '../Loader/DotsLoader/DotsLoader';
import { BI_ACTION_SHEET_DESCRIPTION_1, BI_ACTION_SHEET_DESCRIPTION_2, BI_ACTION_SHEET_HEADING, BI_LOADING_TEXT } from '../../utils/messageText';
import ActionSheetModal from '../PolicySpecficQuestions/ActionSheetModal/ActionSheetModal';
import AxiosRequest from '../../utils/axios';
import { getApiData } from '../../api/api';
import { isIOSDevice } from '../../utils/getDevice';
import { hideProgressBar } from '../../utils/handleProgress';
import LanguageTranslater from '../HOC/LanguageTranslater';
import { Button } from 'unified-ui-components-library';
import { CAPS_Y } from '../../utils/constants';

const axios = new AxiosRequest().getClient();

const BIPage = ({ handleBiPageDisplay, translate }) => {
    const [loading, setLoading] = useState(false)
    const [isBIDownloaded, setIsBIDownloaded] = useState(false)
    const [getBIAttempts, setGetBIAttempts] = useState(0)
    const [downloadAttempts, setDownloadAttempts] = useState(0)
    const [downloadErr, setDownloadErr] = useState(false)
    const [pdfUrl, setPdfUrl] = useState("")
    const [isViewLoaded, setIsViewLoaded] = useState(false)
    const isTelebinding = sessionStorage.getItem("isTelebinding") === CAPS_Y;

    useEffect(() => {
        hideProgressBar()
        return () => {
            const statusEl = document.querySelector('.bar-cntnr')
            if (statusEl) {
                statusEl.style.display = 'block';
            }
        }
    })

    useEffect(() => {
        if (getBIAttempts < 3) {
            getBusinessIllustration()
        }
    }, [getBIAttempts])

    const createBase64FromFileUrl = () => {
        return new Promise((resolve, reject) => {
            fetch(pdfUrl).then(function (t) {
                console.log({ t })
                if (t?.status === 200) {
                    t.blob().then((b) => {
                        const objUrl = URL.createObjectURL(b);
                        const reader = new FileReader();
                        reader.readAsDataURL(b);
                        reader.onloadend = () => {
                            resolve(reader.result)
                            console.log({ reader: reader.result })
                        }
                    }).catch((err) => {
                        console.log({ err })
                        reject({ errMsg: "BLOB ERROR" })
                    });
                } else {
                    reject({ errMsg: "PDF LINK EXPIRED" })
                }
            }).catch((error) => {
                console.log({ error })
                reject({ errMsg: "PDF FETCH ERROR" })
            });
        })
    }

    const getBusinessIllustration = async () => {
        setPdfUrl("")
        setLoading(true)
        try {
            const { url, body } = getApiData("biDetail")
            body.request.payload.posvRefNumber = localStorage.getItem("posvRefNumber");
            const response = await axios.post(url, body)
            console.log({ response })
            if (response?.data?.response?.payload?.biDetailsS3Url) {
                setPdfUrl(response?.data?.response?.payload?.biDetailsS3Url)
            } else {
                setGetBIAttempts((prev) => prev + 1)
            }
            // throw ({ errMsg: "STATIC FAIL" })
        } catch (err) {
            setGetBIAttempts((prev) => prev + 1)
        } finally {
            setLoading(false)
        }
    }

    const retryGetBI = () => {
        setGetBIAttempts((prev) => {
            if (prev < 3) {
                getBusinessIllustration()
            }
            return prev + 1
        })
    }

    const downloadPdf = async () => {
        setDownloadErr(false)
        try {
            const fileData = await createBase64FromFileUrl()
            const a = document.createElement("a");
            a.target = "_blank";
            a.href = fileData
            a.download = "Business Illustration.pdf"
            a.click()
            setIsBIDownloaded(true)
            // console.log({resp})
        } catch (error) {
            console.log({ error })
            setDownloadAttempts((prev) => prev + 1)
            setDownloadErr(true)

        }
    }

    return (
        <div className="biPageWrapper">
            <div className="biPageHeading">
                <p>{translate('Benefit Illustration')}</p>
            </div>
            <p className='biMessageMandatoryDownload'>{translate("It is mandatory to download this document to proceed")}</p>
            <div className={`biPageContent ${isIOSDevice() ? 'iosDvce' : ''}`}>
                {loading && <DotsLoader msg={translate(BI_LOADING_TEXT)} />}
                {pdfUrl && <BenefitIllustration BIAttempts={getBIAttempts} setIsViewLoaded={setIsViewLoaded} setGetBIAttempts={setGetBIAttempts} pdfUrl={pdfUrl} />}
            </div>
            <div className="biPageBtns">
                <div className='biMessageCntnr'>
                    {isBIDownloaded && <p className='biMessage'>{translate("Benefit Illustration downloaded successfully!")}</p>}
                    {downloadErr && <>
                        <p className='biMessage dwnldErr'>{translate("Could not download, please try again")}</p>
                        <p className='biMessage dwnldErr'>{3 - downloadAttempts}/3 {translate("attempts left")}</p>
                    </>}
                </div>
                <div className='biBtns'>
                    <Button
                        className='biDownload'
                        onClick={downloadPdf}
                        disabled={loading || isBIDownloaded || !isViewLoaded}
                        buttonType='primary'
                        width="154"
                        size='small'
                    >
                        {translate("Download PDF")}
                    </Button>
                    <Button
                        className='proceedToOtp'
                        onClick={handleBiPageDisplay}
                        disabled={loading || !isBIDownloaded}
                        buttonType='primary'
                        width="154"
                        size='small'
                    >
                         {isTelebinding ? "Proceed" : translate("Proceed to OTP")}
                    </Button>
                </div>
            </div>
            {(getBIAttempts === 3 || downloadAttempts === 3) && <ActionSheetModal
                heading={translate(BI_ACTION_SHEET_HEADING)}
                description={translate(BI_ACTION_SHEET_DESCRIPTION_1)}
                modalType={"BI_Failed"}
                buttons={[
                    {
                        text: isTelebinding ? "Proceed" : translate("Proceed to OTP"),
                        action: handleBiPageDisplay
                    }
                ]}
            />}
        </div>
    );
}

export default LanguageTranslater(BIPage);